module.exports = __webpack_public_path__ + "media/images/webpage/specials/huistenbosch_2020/cover-2-6cf659afb124206515f5d1fc472b0c63.webp";